import { ErrorMessage, Field } from "formik";
import React from "react";

export default function FieldArea({ title, name, placeholder, key }) {
  return (
    <div key={key} className="form-group">
      <label>{title}</label>
      <Field
        as="textarea"
        name={name}
        placeholder={placeholder}
        className="form-control"
      />
      <ErrorMessage
        name={name}
        component="div"
        className="error"
        style={{ color: "red" }}
      />
    </div>
  );
}
